<template>
  <div class="m-b">
    <table class="table m-b-none">
      <thead>
        <tr>
          <th>
            <abbr title="requerido">*</abbr>
            {{ $I18n.t('activerecord.attributes.calificaciones/conversion_valor.valor_origen') }}
          </th>
          <th>
            <abbr title="requerido">*</abbr>
            {{
              $I18n.t('activerecord.attributes.calificaciones/conversion_valor.valor_convertido')
            }}
          </th>
          <th class="col-min">
            <button
              type="button"
              class="btn btn-cifra btn-xs"
              @click="addValor"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(valor, index) in valoresNoEliminados" :key="index">
          <td>
            <input ref="valorOrigen" v-model="valor.valor_origen" class="form-control">
          </td>
          <td>
            <input ref="valorConvertido" v-model="valor.valor_convertido" class="form-control">
          </td>
          <td>
            <i
              class="fa fa-trash text-danger clickable"
              @click="eliminarValor(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="error" class="text-danger">
      {{ modelErrorsToHtmlText(error) }}
    </p>
  </div>
</template>

<script>
import { modelErrorsToHtmlText } from '../../../../libs/cifra/model_errors';

export default {
  props: {
    modelValue: { type: Array, default: () => [] },
    error: { type: [String, Array], default: null },
  },
  emits: ['update:modelValue'],
  data() {
    const valores = [...this.modelValue];

    return {
      valores,
    };
  },
  computed: {
    valoresNoEliminados() {
      return this.valores.filter((o) => !o._destroy);
    },
  },
  watch: {
    valores: {
      deep: true,
      handler(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    eliminarValor(index) {
      if (index > -1) {
        const valor = this.valores[index];
        if (valor.id == null) {
          this.valores.splice(valor, 1);
        } else {
          valor._destroy = true;
        }
      }
    },
    addValor() {
      this.valores.push({});
      this.$nextTick(() => {
        this.$refs.valorOrigen[this.valores.length - 1].focus();
      });
    },
    modelErrorsToHtmlText,
  },
};
</script>

<style scoped>
  table > tbody > tr > td:last-child {
    text-align: center;
  }
  abbr {
    border: 0;
    text-decoration: none;
    color: #fe1d12;
  }
</style>
